import { render, staticRenderFns } from "./ColorFilter.vue?vue&type=template&id=3030c3f3&scoped=true&"
import script from "./ColorFilter.vue?vue&type=script&lang=js&"
export * from "./ColorFilter.vue?vue&type=script&lang=js&"
import style0 from "./ColorFilter.vue?vue&type=style&index=0&id=3030c3f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3030c3f3",
  null
  
)

export default component.exports